// extracted by css-extract-rspack-plugin
export default {"videoContainer":"_c123b74d","minWFull":"_b73a8cd5"};